import { createSlice } from "@reduxjs/toolkit";
import { IResponseWithPagination } from "src/@types/api";
import { IInquiry } from "src/@types/inquiries";
import { WATCHLIST_SLICE_NAME } from "./actions";
import {
  getWatchlistReducer,
  removeFromWatchlistReducer,
} from "./reducers";

export interface WatchlistState {
  isLoading: boolean;
  items: IResponseWithPagination<IInquiry>;
}

const initialState: WatchlistState = {
  isLoading: false,
  items: null,
};

export const { reducer: watchlist } = createSlice({
  name: WATCHLIST_SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers(builder) {
    getWatchlistReducer(builder);
    removeFromWatchlistReducer(builder);
  },
});
